import { Pipe, PipeTransform } from '@angular/core';

import { NA_VALUE } from '@app/modules/core/constants/global.constants';
import { isAzulAir, isGolAir } from '@flight-results/mappers/flights.mapper';
import { ReservationFlight } from '@user-history/entities/history-booking-detail';
import { mapperReferenceCode } from '@user-history/mappers/flight-reservations.mapper';
import { flightItemMapper } from '@app/mappers/flight-item.mapper'

@Pipe({
  name: 'airReservationFlightFormat',
  standalone: false
})
export class AirReservationFlightFormatPipe implements PipeTransform {

  transform(reservation: ReservationFlight): ReservationFlight {
    return formatReservation(reservation);
  }
}

export function formatReservation(reservation: ReservationFlight): ReservationFlight {
  return {
    ...reservation,
    Sectors: reservation.Sectors.map(sector => {
      return {
        ...sector, Flights: sector.Flights.map(flight => {
          return {
            ...flight,
            AirlineConfirmationCode: mapperReferenceCode(flight?.AirlineCode, flight?.AirlineConfirmationCode)
          };
        })
      };
    }),
    ReferenceCode: mapperReferenceCode(reservation?.Airlines[0]?.Code, reservation.ReferenceCode),
    TripOption: {
      Sectors: reservation.Sectors.map(sector => {
        return {
          ...sector,
          Flights: sector.Flights.map(flight => ({
            ...flight,
            BaggageRestrictions: flight.BaggageRestrictions === NA_VALUE ? isGolAir(flight.AirlineCode) ? '0' :
              isAzulAir(flight.AirlineCode) ? '1' : flight.AirlineCode : flight.BaggageRestrictions,
            AirlineConfirmationCode: mapperReferenceCode(flight?.AirlineCode, flight?.AirlineConfirmationCode)
          })),
          FlightItem: flightItemMapper(sector)
        };
      })
    }
  }
}
